import React from "react";
import classNames from "classnames";
import PropTypes from "prop-types";

import Sidebar from "components/Library/Layout/Sidebar";
import Content from "components/Library/Layout/Content";

import styles from "./StandardLayout.css";

export default function StandardLayout(props) {
  return (
    <div className={classNames(styles.root, props.className)}>
      <Sidebar>{props.complementary}</Sidebar>
      <Content className={styles.content} ariaLabel={props.mainAriaLabel}>
        {props.main}
      </Content>
    </div>
  );
}

StandardLayout.defaultProps = {
  mainAriaLabel: "Stories",
};

StandardLayout.propTypes = {
  complementary: PropTypes.node,
  main: PropTypes.node.isRequired,
  mainAriaLabel: PropTypes.string,
  className: PropTypes.string,
};
